module.exports = __webpack_public_path__ + "static/apple_store_badge-ab8871d0ab8fc10b36981e0cb6e14024.svg";